module.exports = __webpack_public_path__ + "img/funktionen.bb76bef3.svg";